module.exports = __webpack_public_path__ + "img/logo_wordmark_white.99de58cf.svg";